function formatMoney(amount) {
  return new Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active
  }).format(amount / 100);
}

let cartUpsellSwiper = null;

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function waitForLineItems() {
  return new Promise(resolve => {
    const check = () => {
      const items = document.querySelectorAll("line-item[data-ctl]");
      if (items.length > 0) resolve();
      else requestAnimationFrame(check);
    };
    check();
  });
}

async function loadCartUpsellProducts() {
  await waitForLineItems();

  const wrapper = document.getElementById("cart-upsell-products");
  const container = document.getElementById("cart-upsell");
  if (!wrapper || !container) return;

  wrapper.innerHTML = "";

  const cart = await fetch("/cart.js").then(r => r.json());
  if (!cart.items.length) {
    container.style.display = "none";
    return;
  }

  let allHandles = [];

  cart.items.forEach(item => {
    const el = document.querySelector(`[data-line-key="${item.key}"]`);
    if (!el) return;

    let ctl = [];
    try { ctl = JSON.parse(el.dataset.ctl || "[]"); } catch (e) {}

    ctl.forEach(handle => {
      if (!allHandles.includes(handle)) allHandles.push(handle);
    });
  });

  if (!allHandles.length) {
    container.style.display = "none";
    return;
  }

  container.style.display = "block";

   requestAnimationFrame(() => {
    container.style.opacity = "1";
  });
  allHandles = shuffleArray(allHandles).slice(0, 8);

  for (const handle of allHandles) {
    const p = await fetch(`/products/${handle}.js`).then(r => r.json());
    wrapper.innerHTML += `
      <div class="swiper-slide drawer-upsell__item">
        <a href="/products/${p.handle}" class="drawer-upsell__card">
          <img src="${p.featured_image}" alt="${p.title}">
          <p class="drawer-upsell__title-small">${p.title}</p>
          <p class="drawer-upsell__price">${formatMoney(p.price)}</p>
        </a>
      </div>
    `;
  }

  initCartUpsellSwiper();
}

function initCartUpsellSwiper() {
  if (cartUpsellSwiper) cartUpsellSwiper.destroy(true, true);

  cartUpsellSwiper = new Swiper(".drawer-upsell__swiper", {
    slidesPerView: 2.2,
    spaceBetween: 12,
    freeMode: true,
     navigation: {
      nextEl: ".drawer-upsell__next",
      prevEl: ".drawer-upsell__prev",
    }
  });
}

/* ---------------------------
   MUTATION OBSERVER – STABLE VERSION
--------------------------- */

let upsellObserver = null;
let observerTimeout = null;

function observeCartDrawer() {
  if (upsellObserver) return;

  upsellObserver = new MutationObserver((mutations) => {

    let shouldRun = false;

    for (const m of mutations) {

      // Only react when children of cart drawer or line items change
      if (
        (m.target.id === "cart-drawer") ||
        m.target.classList?.contains("cart-drawer__items") ||
        [...m.addedNodes].some(n => n.nodeType === 1 && n.matches?.("line-item"))
      ) {
        shouldRun = true;
        break;
      }
    }

    if (shouldRun) {
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(() => {
        loadCartUpsellProducts();
      }, 200); // strong debounce
    }
  });

  upsellObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}


document.addEventListener("DOMContentLoaded", () => {
  observeCartDrawer();
  loadCartUpsellProducts();
});

document.addEventListener("cart:change", loadCartUpsellProducts);
document.addEventListener("cart:refresh", loadCartUpsellProducts);
document.addEventListener("cart-drawer:opened", loadCartUpsellProducts);
document.documentElement.addEventListener("theme:loading:end", loadCartUpsellProducts);
